<!-- eslint-disable max-len -->
<route>
    {
      "meta": {
        "requireAdmin": true,
        "customSite": true
      }
    }
    </route>
<template>
  <div class="py-5 w-full">
    <!-- -------------------------------------------header tab section--------------------------  -->
    <section
      class="flex flex-col lg:flex-row lg:justify-between lg:items-center"
    >
      <div class="flex items-baseline max-w-xs">
        <h5 class="text-2xl mr-5 font-semibold">List:</h5>
        <select
          class="select select-bordered w-full"
          required
          v-model="currentSegemnt"
          @change="($event)=>{
            this.$store.commit('SET_CURRENT_SEGMENT', $event.target.value);
            }"
        >
          <option disabled="disabled" value="">Recently Engaged</option>
          <option
            v-for="(item, index) in courses"
            :value="item._id"
            :key="index"
          >
            {{ item.title.slice(0, 30)
            }}{{ item.title.length > 30 ? '...' : '' }}
          </option>
        </select>
      </div>
      <div class="flex">
        <TabButtons
          label="Replies"
          :callback="(e) => handlePageChange(e)"
          :currentValue="currentComponent"
        />
        <TabButtons
            label="DMs"
            :callback="(e) => handlePageChange(e)"
            :currentValue="currentComponent"
        />
      </div>
    </section>

    <!-- segment selection section -->
    <!-- ---------------------------------------------------overview ------------------------------------->
    <section v-if="currentComponent == 'Replies'" class="w-full">
      <Replies :listActivity="listActivity" :totalTweets="totalTweets" />
    </section>
    <!-- ---------------------------------------------------activity ------------------------------------->
    <section v-if="currentComponent == 'DMs'">
      <DMs />
    </section>
  </div>
</template>
<script>
// import userInfo from '@/services/userInfo';
// import courseAPI from '@/services/course';
import TabButtons from '@/components/Audience/TabButtons.vue';
import Replies from '@/components/Engage/Replies.vue';
import DMs from '@/components/Engage/DMs.vue';
import utils from '@/services/utils';

export default {
  name: 'engage',
  layout: 'admin',
  data() {
    return {
      userInfo: null,
      currentComponent: 'Replies',
      courseId: '',
      currentCourse: '',
      userId: '',
      listActivity: {},
      totalTweets: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userDetails() {
      return this.$store.state?.userDetails;
    },
    currentSegemnt: {
      get() {
        return this.$store.state.connect.currentSegment;
      },
      set(newValue) {
        return newValue.toString();
      },
    },
    courses() {
      return this.$store.state.courses.courses || [];
    },
  },
  components: { TabButtons, Replies, DMs },
  watch: {
    userDetails(newVal) {
      this.userId = newVal?.userId;
    },
  },
  async mounted() {
    await this.$store.dispatch('getMyDetails', {});
    // this.userId = this.userInfo?.user?.userId;
    // if (this.$route.query.userId) {
    //   this.userId = this.$route.query.userId;
    // }
    if (!this.courses.length) {
      this.fetchCourse();
    }
  },
  methods: {
    async fetchCourse() {
      try {
        this.$store.commit('toggleLoading', true);
        await this.$store.dispatch('fetchCoursesList', { userId: this.userId });
        this.$store.commit('toggleLoading', false);
      } catch (error) {
        utils.setStatusMsg(error?.message || 'Something went wrong');
        this.$store.commit('toggleLoading', false);
      }
    },
    handlePageChange(e) {
      this.currentComponent = e;
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
.reaction:hover {
  @apply cursor-pointer;
}
.audience_header {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.1rem;
}
</style>
